import type { ReactNode } from 'react';

/**
 * One checkbox with its words, for a single choice inside a form ("Sign out of other devices"), and what
 * the choice leaves alone under it when that matters (`note`)
 */
export function Check({ label, checked, onChange, disabled, note }: { label: string; checked: boolean; onChange: (checked: boolean) => void; disabled?: boolean; note?: ReactNode }) {
	const box = (
		<label className="flex min-h-11 cursor-pointer items-center gap-3 text-body text-ink">
			<input type="checkbox" className="h-4 w-4 accent-current" checked={checked} disabled={disabled} onChange={event => onChange(event.target.checked)} />
			<span>{label}</span>
		</label>
	);
	if (!note) return box;
	return (
		<div>
			{box}
			<p className="ms-7 text-small text-ink-muted">{note}</p>
		</div>
	);
}
